export {}

const initRangeSlider = () => {
  const rangeSliderFields = document.querySelectorAll<HTMLElement>(".f-range-slider")

  rangeSliderFields.forEach((rangeSlider) => {
    const fromSlider = rangeSlider.querySelector<HTMLInputElement>(".f-range-slider__range.--from")
    const toSlider = rangeSlider.querySelector<HTMLInputElement>(".f-range-slider__range.--to")
    const fromInput = rangeSlider.querySelector<HTMLInputElement>(".f-range-slider__control.--from input")
    const toInput = rangeSlider.querySelector<HTMLInputElement>(".f-range-slider__control.--to input")
    const fromLabel = rangeSlider.querySelector<HTMLElement>(".f-range-slider__label.--from")
    const toLabel = rangeSlider.querySelector<HTMLElement>(".f-range-slider__label.--to")

    if (!fromSlider || !toSlider || !fromInput || !toInput || !fromLabel || !toLabel) return

    const controlFromInputs = () => {
      if (!fromInput.value) fromInput.value = fromSlider.min
      if (parseInt(fromInput.value) > parseInt(toInput.value)) {
        fromSlider.value = toInput.value
        fromInput.value = toInput.value
      } else {
        fromSlider.value = fromInput.value
      }

      fillSlider()
    }

    const controlToInputs = () => {
      if (!toInput.value) toInput.value = toSlider.max
      if (parseInt(fromInput.value) <= parseInt(toInput.value)) {
        toSlider.value = toInput.value
      } else {
        toSlider.value = fromInput.value
        toInput.value = fromInput.value
      }

      fillSlider()
    }

    const controlFromRanges = () => {
      if (parseInt(fromSlider.value) > parseInt(toSlider.value)) {
        fromSlider.value = toSlider.value
        fromInput.value = toSlider.value
      } else {
        fromInput.value = fromSlider.value
      }

      fillSlider()
    }

    const controlToRanges = () => {
      if (parseInt(fromSlider.value) <= parseInt(toSlider.value)) {
        toInput.value = toSlider.value
      } else {
        toSlider.value = fromSlider.value
        toInput.value = fromSlider.value
      }

      fillSlider()
    }

    const fillSlider = () => {
      const rangeDistance = parseInt(toSlider.max) - parseInt(toSlider.min)
      const fromPosition = parseInt(fromSlider.value) - parseInt(toSlider.min)
      const toPosition = parseInt(toSlider.value) - parseInt(toSlider.min)

      fromLabel.innerHTML = `${fromSlider.value}`
      toLabel.innerHTML = `${toSlider.value}`

      const thumbSize = 16
      const sliderWidth = fromSlider.offsetWidth
      const fromLabelWidth = fromLabel.offsetWidth
      const toLabelWidth = toLabel.offsetWidth

      const ratio = (sliderWidth - thumbSize) / rangeDistance
      const fromLeft = fromPosition * ratio - fromLabelWidth / 2 + thumbSize / 2
      const toLeft = toPosition * ratio - toLabelWidth / 2 + thumbSize / 2 + thumbSize

      rangeSlider.style.setProperty("--background-from", `${(fromPosition / rangeDistance) * 100}%`)
      rangeSlider.style.setProperty("--background-to", `${(toPosition / rangeDistance) * 100}%`)
      fromLabel.style.setProperty("left", `${fromLeft}px`)
      toLabel.style.setProperty("left", `${toLeft}px`)
    }

    fromSlider?.addEventListener("input", controlFromRanges)
    toSlider?.addEventListener("input", controlToRanges)
    fromInput?.addEventListener("change", controlFromInputs)
    toInput?.addEventListener("change", controlToInputs)
    window.addEventListener("resize", fillSlider)

    fillSlider()
  })
}

initRangeSlider()
document.addEventListener("rangeReinit", initRangeSlider)
